export default __webpack_public_path__ + "static/media/Mark-4-HUD-Label.898bd852.jpg";